import { useState, useEffect } from "react";

type ViewType = "grid" | "list";

const useViewType = () => {
  const [viewType, _setViewType] = useState<ViewType>("grid");

  useEffect(() => {
    const savedViewType = localStorage.getItem("viewType");
    if (
      savedViewType &&
      (savedViewType === "grid" || savedViewType === "list")
    ) {
      _setViewType(savedViewType);
    }
  }, []);

  const setViewType = (type: ViewType) => {
    _setViewType(type);
    localStorage.setItem("viewType", type);
  };

  const toggleViewType = () => {
    const newType = viewType === "grid" ? "list" : "grid";
    _setViewType(newType);
    localStorage.setItem("viewType", newType);
  };

  return { viewType, setViewType, toggleViewType };
};

export default useViewType;
